import { useEffect } from 'react';

const useModernAssets = () => {
  useEffect(() => {
    // Bootstrap 5 belongs to the three marketing routes only (/, /pricing,
    // /about-us) and is loaded HERE rather than globally so it is removed again
    // on unmount. Loading it globally breaks every app page that uses a bare
    // `.col`: Bootstrap's `.col{flex:1 0 0%}` sets flex-basis:0, which beats the
    // explicit `width` our own styles give those cards, collapsing a row of them
    // into equal slivers. 118 call sites across 56 components are affected.

    const assets = [
      { type: 'link', id: 'bootstrap5-css', href: 'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css' },
      { type: 'link', id: 'swiper-css', href: 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css' },
      { type: 'script', id: 'bootstrap5-js', src: 'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.bundle.min.js' },
      { type: 'script', id: 'swiper-js', src: 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js' }
    ];

    
    assets.forEach(asset => {
      if (document.getElementById(asset.id)) return;

      if (asset.type === 'link') {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = asset.href;
        link.id = asset.id;
        document.head.appendChild(link);
      } else {
        const script = document.createElement('script');
        script.src = asset.src;
        script.id = asset.id;
        script.async = true;
        document.body.appendChild(script);
      }
    });

    // Add CSS containment to prevent Bootstrap 5 from affecting outside elements
    const containmentStyle = document.createElement('style');
    containmentStyle.id = 'modern-layout-containment';
    containmentStyle.textContent = `
      .modern-v5-scope {
        isolation: isolate;
      }
      /* Prevent Bootstrap 5 utilities from affecting outside elements */
      .modern-v5-scope * {
        box-sizing: border-box;
      }
    `;
    document.head.appendChild(containmentStyle);

    // Cleanup function: Removes the assets when the component unmounts
    return () => {
      const containment = document.getElementById('modern-layout-containment');
      if (containment) containment.remove();
      
      assets.forEach(asset => {
        const el = document.getElementById(asset.id);
        if (el) el.remove();
      });
    };
  }, []);
};

export default useModernAssets;